import { render, staticRenderFns } from "./jobManagement.vue?vue&type=template&id=2594c23a&scoped=true&"
import script from "./jobManagement.vue?vue&type=script&lang=js&"
export * from "./jobManagement.vue?vue&type=script&lang=js&"
import style0 from "./jobManagement.vue?vue&type=style&index=0&id=2594c23a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594c23a",
  null
  
)

export default component.exports